import { createSlice } from '@reduxjs/toolkit';

const NotificationSlice = createSlice({
  name: 'NotificationSlice',
  initialState: {
    open: false,
    message: '',
    severity: 'success', // 'success', 'error', 'warning', 'info'
  },
  reducers: {
    showSnackbar: (state, action) => {
      const { message, severity } = action.payload;
      state.open = true;
      state.message = message;
      state.severity = severity || 'success';
    },
    hideSnackbar: (state) => {
      state.open = false;
    },
  },
});

export const { showSnackbar, hideSnackbar } = NotificationSlice.actions;
export default NotificationSlice;